import {DoppeViewerLang} from "../doppe-viewer-lang";

export function doppeViewerIntlDateTimeFormatShortMonth (
    doppeViewerLang: DoppeViewerLang,
    date: Date | number
) {
    return Intl.DateTimeFormat(doppeViewerLang, {month: 'short'}).format(date)
}

export function doppeViewerIntlDateTimeFormatShortMonthAndDay (
    doppeViewerLang: DoppeViewerLang,
    date: Date | number
) {
    return Intl.DateTimeFormat(doppeViewerLang, {month: 'short', day: 'numeric'}).format(new Date(date))
}

